module.exports = __webpack_public_path__ + "src/img/selectIconOn.67c63da9.svg";